import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    // 添加清除 token 的 mutation
    CLEAR_TOKEN(state) {
      state.token = null;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    // 添加清除 token 的 action
    clearToken({ commit }) {
      commit('CLEAR_TOKEN');
     
    }
  }
});